module.exports = __webpack_public_path__ + "Flag-174.23860e467b9a772fdf83350cddb36bd3.svg";